export const closeFullscreen = () => {
	document.exitFullscreen();
};
